import * as React from 'react';

import { createIcon } from '../Icon';
export const MinusIcon = createIcon(
  <line x1={5} y1={12} x2={19} y2={12} />,
  'MinusIcon'
);
